<template>
  <OAuthApplicationCreate @created="handleCreated" @closed="emit('closed')" />
</template>

<script setup lang="ts">
import { EVENT_SITES } from '@crossbeam/itly';

import { useHead } from '@unhead/vue';

import OAuthApplicationCreate from '@/components/OAuthApplicationCreate.vue';

import useApiControlsTracking from '../useApiControlsTracking';

const emit = defineEmits<{
  closed: [];
}>();

useHead({ title: 'Create Integration - API Integrations - API - Crossbeam' });

const { trackApiControlAction } = useApiControlsTracking();

function handleCreated(applicationId: string) {
  trackApiControlAction({
    eventSite: EVENT_SITES.API_INTEGRATION_CREATE_MODAL,
    type: 'create_submitted',
    resource: 'integration',
    resourceId: applicationId,
  });
}
</script>
